module.exports = new __parcel__URL__("28207_sq.5d5be147.jpg").toString();